import { Board, Council } from 'types';
import { BoardEntityTypes } from 'types/Board';
import boardStatus from 'constants/boardStatus';
import councilStatus from 'modules/administratives/constants/councilStatus';
import { boardEntityTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardEntityTypes';

type BoardStatus = Record<
  string,
  {
    value: string;
    text: string;
    style: string;
    icon: string;
  }
>;

type CouncilStatus = {
  value: string;
  label: string;
  badge: string;
  icon: string;
}[];

type FinalStatus = {
  value: string;
  label: string;
  badge: string;
  icon: string;
};

const getStatus = (
  board: Board | Council,
  boardType: BoardEntityTypes
): FinalStatus => {
  let status = null;

  const statusList =
    boardType === boardEntityTypes.COUNCIL
      ? (councilStatus as CouncilStatus)
      : (boardStatus as BoardStatus);

  if (boardType === boardEntityTypes.COUNCIL) {
    status = (statusList as CouncilStatus).find(
      (status) => status.value === board?.status
    );

    return {
      value: status?.value || '',
      label: status?.label || '-',
      badge: status?.badge || '-',
      icon: status?.icon || '-',
    };
  }

  if (boardType === boardEntityTypes.BASIC_BOARD) {
    status = (statusList as BoardStatus)[board.status];

    return {
      value: status?.value || '',
      label: status?.text || '-',
      badge: status?.style || '-',
      icon: status?.icon || '-',
    };
  }

  return {
    value: '',
    label: '-',
    badge: '-',
    icon: '-',
  };
};

export const getBoardStatusData = (
  board: Council | Board | null | undefined,
  boardType: BoardEntityTypes
) => {
  if (!board) {
    return {
      statusLabel: '-',
      statusBadge: '-',
      statusIcon: '-',
      statusValue: '',
    };
  }

  const status = getStatus(board, boardType);

  const {
    value: statusValue,
    label: statusLabel,
    badge: statusBadge,
    icon: statusIcon,
  } = status;

  return { statusLabel, statusBadge, statusIcon, statusValue };
};
